<template>
  <div v-loading="loading">
    <vue-csv-import
    v-model="customers"
    :map-fields="mapFields">
      <template slot="hasHeaders" slot-scope="{headers, toggle}">
        <label>
          <input type="checkbox" id="hasHeaders" :value="headers" @change="toggle">
          O arquivo tem cabeçalhos?
        </label>
      </template>

      <template slot="thead">
        <tr>
          <th>Campo</th>
          <th>Referência no arquivo</th>
        </tr>
      </template>

      <template slot="next" slot-scope="{load}">
        <button
          @click.prevent="load"
          class="btn btn-fill btn-wd btn-success btn-block"
        >
          Carregar arquivo
        </button>
      </template>
    </vue-csv-import>
    <button
      v-if="customers.length"
      @click="handleImport()"
      class="btn btn-fill btn-wd btn-success btn-block"
    >
      Confirmar Tickets
    </button>
  </div>
</template>

<script>
import Couchdb from 'src/services/Couchdb'
import { mapGetters, mapActions } from 'vuex'
import { VueCsvImport } from 'vue-csv-import'

export default {
  name: 'btn-tickets-confirm',
  components: {
    VueCsvImport
  },
  computed: {
    ...mapGetters(['config', 'user']),
    eventId () {
      return this.$route.params.id
    }
  },
  data () {
    return {
      loading: false,
      mapFields: [
        'uc',
        'nome',
        'cpf',
        'confirmado'
      ],
      customers: []
    }
  },
  methods: {
    ...mapActions('customers', ['fetchOne', 'fetchAll', 'resetOne', 'insert', 'update', 'upsert']),
    ...mapActions('winners', { winnerByConfig: 'winnerByConfig' }),
    ...mapActions('tickets', { updateTicket: 'upsert', fetchTickts: 'fetchAll', createTicket: 'createTicket', getTicketBarcode: 'getTicketBarcode', checkWinnerOld: 'checkWinnerOld', isWinnerTrgNewer: 'isWinnerTrgNewer' }),
    async handleImport () {
      this.loading = true
      // let customersIds = []
      await this.asyncForEach(this.customers, async customer => {
        if (customer.UC === 'uc') {
          return
        }
        const customerDB = await this.getCustomer(customer)

        const status = customer.confirmado.toLowerCase()
        // console.log('status', status, 'customers', customerDB)

        const tickets = await Couchdb.connection('default').collection('tickets').where('customerId', customerDB._id).where('eventId', this.eventId).get()

        if (tickets.length > 0) {
          let ticket = tickets[0]
          switch (status) {
            case 'faltou':
              // console.log('faltou', ticket._id)
              ticket.checkIn = false
              ticket.winner = false
              break
            case 'reserva/ok':
              // console.log('reserva', ticket._id)
              ticket.checkIn = true
              ticket.winner = true
              break
            default:
              // console.log('ok', ticket._id)
              ticket.checkIn = true
              break
          }

          await this.updateTicket(ticket)
        }
      })
      setTimeout(() => {
        this.loading = false
        window.location.reload(true)
      }, 2000)
    },
    getCustomer (customer) {
      return new Promise(async (resolve, reject) => {
        let constumerResolve = null
        let costumerUC = await Couchdb.connection('default').where('uc', customer.uc).limit(1).get()
        let costumerCPF = await Couchdb.connection('default').where('uc', customer.cpf).limit(1).get()
        costumerUC = costumerUC.length > 0 ? costumerUC[0] : costumerUC
        costumerCPF = costumerCPF.length > 0 ? costumerCPF[0] : costumerCPF
        // console.log('UC', costumerUC)
        // console.log('CPF', costumerCPF)
        const customerIDs = {
          idUc: false,
          idCpf: false
        }

        if (costumerUC && costumerUC.uc === customer.uc) {
          constumerResolve = costumerUC
          customerIDs.idUc = costumerUC._id
        }

        if (costumerCPF && costumerCPF.cpf === customer.cpf) {
          constumerResolve = costumerCPF
          customerIDs.idCpf = costumerCPF._id
        }

        if (this.config.validationCustomer.uc && this.config.validationCustomer.cpf && costumerUC && costumerCPF && customerIDs.idUc && customerIDs.idCpf) {
          // Atualizar o cliente pela UC
          constumerResolve = costumerUC
        }

        if ((this.config.validationCustomer.uc) && costumerUC > 0 && !this.config.validationCustomer.cpf && customerIDs.idUc) {
          // Atualizar o cliente pela UC
          constumerResolve = costumerUC
        }

        if ((this.config.validationCustomer.cpf) && costumerCPF > 0 && !this.config.validationCustomer.uc && customerIDs.idCpf) {
          // Atualizar o cliente pela CPF
          constumerResolve = costumerCPF
        }

        if ((this.config.validationCustomer.ucOrCpf) && costumerCPF > 0 && (customerIDs.idUc || customerIDs.idCpf)) {
          // Atualiza o cliente preferencialmente pela UC caso contrario usa o do CPF
          constumerResolve = costumerUC
          if (!costumerUC) {
            constumerResolve = costumerCPF
          }
        }
        resolve(constumerResolve)
      })
    },
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnTicketsConfirm.vue